<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="tile is-ancestor">
      <div class="tile is-child" v-if="isAdmin">
        <LightSensor/>
      </div>
      <div class="tile is-child">
        <ControlPanel/>
      </div>
    </div>
    
    <Chart :sampleIds="samplesToshow" />
    <SelectedFolder/>
    <SampleGrid 
      @show="showSampleChart" 
      @hide="hideSampleChart"
      />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import LightSensor from '../components/LightAndTemperature.vue';
import ControlPanel from '../components/ControlPanel.vue';
import Chart from '../components/Chart.vue';
import SampleGrid from '../components/SampleGrid.vue';
import SelectedFolder from '../components/SelectedFolder.vue';

export default {
  name: 'App',
  components: {
    // HelloWorld
    ControlPanel,
    Chart,
    SampleGrid,
    SelectedFolder,
    LightSensor
  },
  data() {
    return {
      samplesToshow: []
    }
  },
  computed:{
    isAdmin(){
      return this.$store.state.isAdmin;
    }
  },
  methods: {
    showSampleChart(sampleId) {      
      this.samplesToshow.push(sampleId);
    },
    hideSampleChart(sampleId){
      const index = this.samplesToshow.indexOf(sampleId);
      if(index >= 0)
        this.samplesToshow.splice(index,1);
    }
  },
}
</script>

<style lang="scss">
@import '@/design/index.scss';
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   margin-top: 60px;
// }
</style>
